<template>
  <div>
    <p style="text-align: center">
      <span class="systemFont0">{{ $t("p0412.defaultOffer") }}</span>
    </p>
    <div class="main">
      <el-form
        class="systemFont1"
        :model="couponSetForm"
        label-width="150px"
        style="width:90%;"
        ref="couponSetFormRef"
        hide-required-asterisk
        label-position="right"
      >
        <!-- 课程编号 -->
        <el-form-item
          :label="$t('p0412.courseNumber')"
          prop="courseNumber6s"
          :rules="courseNumber6s"
        >
          <el-select
            v-model="couponSetForm.courseNumber6s"
            size="courseSelect"
            style="width: 100%"
            :placeholder="$t('common.pleaseSelect')"
            @change="changeCourseNumber"
          >
            <el-option
              v-for="item in courseNumberList"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 课程名称 -->
        <el-form-item
          :label="$t('p0412.courseName')"
          prop="courseName"
          :rules="courseName"
        >
          <el-select
            v-model="couponSetForm.courseName"
            size="courseSelect"
            style="width: 100%"
            :placeholder="$t('common.pleaseSelect')"
            @change="changeCourseName"
          >
            <el-option
              v-for="item in courseNameList"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 学员优惠 -->
        <el-form-item :label="$t('p0412.studentDiscount')">
          <el-col :span="10">
            <el-form-item label-width="0px">
              <el-radio-group v-model="couponSetForm.couponType" style="text-align: left;width:390px">
                <el-radio label="0" @change="changeStuNo">{{$t("p0412.deductionAmount")}}
                </el-radio>
                <el-radio label="1" @change="changeStuRate" style="margin-top:45px">{{$t("p0412.deductionRatio")}}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="9" :offset="1" >
            <el-form-item label-width="0px" prop="studentNumber" :rules="studentNumber" style="margin-bottom:20px">
              <el-input v-model="couponSetForm.studentNumber" @blur="formatStuNumber" size="small" :disabled="couponSetForm.couponType==1 ? true:false"></el-input>
            </el-form-item>
            <el-form-item label-width="0px" prop="studentRate" :rules="studentRate">
              <el-input v-model="couponSetForm.studentRate" size="small" :disabled="couponSetForm.couponType==1 ? false:true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3" :offset="1">
            <el-form-item label-width="0px" style="margin-bottom:20px"><span style="color: #606266;font-weight: 500;" >({{couponSetForm.couponCurrency}})</span></el-form-item>
            <el-form-item label-width="0px"><span style="color: #606266;font-weight: 500;">%</span></el-form-item>
          </el-col>
        </el-form-item>
        <!-- 介绍人佣金 -->
        <el-form-item :label="$t('p0412.introducerCommission')" style="margin-top:-11px">
          <el-col :span="10">
            <el-form-item label-width="0px">
              <el-radio-group v-model="couponSetForm.commissionType" style="text-align: left;width:390px">
                <el-radio label="0" @change="changeIntNo">{{$t("p0412.fixedAmount")}}
                </el-radio>
                <el-radio label="1" @change="changeIntRate" style="margin-top:45px">{{$t("p0412.ratio")}}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="9" :offset="1">
            <el-form-item label-width="0px" prop="introducerNumber" :rules="introducerNumber" style="margin-bottom:20px">
              <el-input v-model="couponSetForm.introducerNumber" @blur="formatIntNumber" size="small" :disabled="couponSetForm.commissionType==1 ? true:false"></el-input>
            </el-form-item>
            <el-form-item label-width="0px" prop="introducerRate" :rules="introducerRate">
              <el-input v-model="couponSetForm.introducerRate" size="small" :disabled="couponSetForm.commissionType==1 ? false:true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3" :offset="1">
            <el-form-item label-width="0px" style="margin-bottom:20px"><span style="color: #606266;font-weight: 500;">({{couponSetForm.commissionCurrency}})</span></el-form-item>
            <el-form-item label-width="0px"><span style="color: #606266;font-weight: 500;">%</span></el-form-item>
          </el-col>
        </el-form-item>
      </el-form>
    </div>
    <div style="text-align: center;margin-top:30px">
      <el-button type="submit" @click.native.prevent="handleSubmit">{{
        $t("common.submit")
      }}</el-button>
      <el-button type="return" class="buttonWidth" @click.native.prevent="handleReturn">{{
        $t("common.back")
      }}</el-button>
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  data() {
    return {
      // 表单
      couponSetForm:{
        // 领域
        field:"",
        // 类别
        category:"",
        // 课程编号
        courseNumber:"",
        courseNumber6s: "",
        // 课程名称
        courseName: "",
        // 学员优惠选择
        couponType: "0",
        // 学员优惠金额
        studentNumber: "",
        // 学员优惠百分比
        studentRate: "",
        // 介绍人选择
        commissionType: "0",
        // 介绍人优惠金额
        introducerNumber: "",
        // 介绍人优惠百分比
        introducerRate: "",
        // 报价货币
        couponCurrency: "CNY",
        commissionCurrency: "CNY",
        createUser:localStorage.getItem("userId"),
      },
      // 旧表单
      oldCouponSetForm:{},
      // 学员优惠金额
      studentNumberOld: "",
      // 学员优惠百分比
      studentRateOld: "",
      // 介绍人优惠金额
      introducerNumberOld: "",
      // 介绍人优惠百分比
      introducerRateOld: "",
      // 课程编号列表
      courseNumberList: [],
      // 课程名称列表
      courseNameList: [],
      // 校验
      courseNumber6s:[{required: true, message:this.$t('p0412.enterNumber'), trigger: 'blur'}],
      courseName:[{required: true, message:this.$t('p0412.enterName'), trigger: 'blur'}],
      studentNumber:[{pattern:/^(0|([1-9][0-9]*)(\.\d+)?|0(\.\d+)?)$/,message:this.$t('p0412.twoDecimals'), trigger: 'blur'}],
      studentRate:[{pattern:/^([1-9]\d|\d)$/, message:this.$t('p0412.integer'), trigger: 'blur'}],
      introducerNumber:[{pattern:/^(0|([1-9][0-9]*)(\.\d+)?|0(\.\d+)?)$/, message:this.$t('p0412.twoDecimals'), trigger: 'blur'}],
      introducerRate:[{pattern:/^([1-9]\d|\d)$/, message:this.$t('p0412.integer'), trigger: 'blur'}],
    };
  },
  mounted() {
    this.initData()
  },
  methods: {
    // 初始化
    initData(){
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container"),
      });
      let url = "/api/couponCode/initCoupon";
      this.$http
        .post(
          url
        )
        .then((response) => {
          this.oldCouponSetForm=JSON.stringify(this.couponSetForm);
          // 课程编号下拉框数据
          this.courseNumberList = response.data.data.courseNumberList;
          // 课程名称下拉框数据
          this.courseNameList = response.data.data.courseNameList;
          loading.close();
        })
        .catch((err) => {
          loading.close();
          console.log(err);
          this.$message.error(this.$t("p0211.errorOccurred"));
        });
    },
    // 比较数据是否发生变更
    couponSetChanged() {
      if (this.oldCouponSetForm===JSON.stringify(this.couponSetForm)) {
        this.$message({
          message: this.$t('common.contentIsUnchanged'),
          type: "warning",
        });
        return true;
      }
      return false;
    },
    // 提交按钮
    handleSubmit(){
      this.$refs["couponSetFormRef"].validate((valid) => {
          if (valid) {
              if(this.couponSetChanged()){
            return
          }
          const loading = this.$loading({
            lock: true,
            text: this.$t("common.loading"),
            background: "rgba(255,255,255,0.8)",
            target: document.querySelector("#main-container"),
          });
          let url = "/api/couponCode/submitCouponSet";
          this.$http
            .post(
              url,this.couponSetForm
            )
            .then((response) => {
              if (response.data.code === 200){
                this.$message.success(this.$t("p0412.OfferSetSuccess"));
                // this.$refs["couponSetFormRef"].resetFields();
                this.studentNumberOld=this.couponSetForm.studentNumber
                this.studentRateOld=this.couponSetForm.studentRate
                this.introducerNumberOld=this.couponSetForm.introducerNumber
                this.introducerRateOld=this.couponSetForm.introducerRate
                this.initData()
              }else{
                this.$message.error(response.data.message);
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
              console.log(err);
              this.$message.error(this.$t("common.anErrorOccurred"));
            });
        }
      })
    },
    // 返回按钮
    handleReturn(){
      this.$router.go(-1)
    },
    // 改变课程编号
    changeCourseNumber(){
      if(this.couponSetForm.courseNumber6s!=null && this.couponSetForm.courseNumber6s!=""){
        this.$refs.couponSetFormRef.clearValidate('courseNumber6s')
      }
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container"),
      });
      let url = "/api/couponCode/changeNumber";
      this.$http
        .post(
          url,qs.stringify({courseNumber6s:this.couponSetForm.courseNumber6s})
        )
        .then((response) => {
          // console.log("response:" + JSON.stringify(response.data.data));
          this.couponSetForm.field=response.data.data.field
          this.couponSetForm.category=response.data.data.category
          this.couponSetForm.courseNumber=response.data.data.courseNumber
          this.couponSetForm.courseName=response.data.data.courseName
          // 学员优惠
          if(response.data.data.couponType!=1){
            // 金额
            this.couponSetForm.couponType="0"
          }else{
            // %
            this.couponSetForm.couponType=response.data.data.couponType
          }
          if(response.data.data.studentNumber!="" && response.data.data.studentNumber!=null){
            // 货币格式
            if(response.data.data.studentNumber==0){
              this.couponSetForm.studentNumber="0.00";
            }else{
              if (response.data.data.studentNumber.toString().includes(".")) {
                this.couponSetForm.studentNumber = response.data.data.studentNumber.toString().split(".")[1].length < 2 ? response.data.data.studentNumber.toString() + "0" : response.data.data.studentNumber;
              }else{
                this.couponSetForm.studentNumber=response.data.data.studentNumber.toString()+".00"
              }
            }
          }else if(response.data.data.studentNumber==0){
            this.couponSetForm.studentNumber="0.00";
          }else{
            this.couponSetForm.studentNumber=response.data.data.studentNumber
          }
          this.couponSetForm.studentRate=response.data.data.studentRate
          // 介绍人优惠
          if(response.data.data.commissionType!=1){
            // 金额
            this.couponSetForm.commissionType="0"
          }else{
            // %
            this.couponSetForm.commissionType=response.data.data.commissionType
          }
          if(response.data.data.introducerNumber!=null && response.data.data.introducerNumber!=""){
            // 货币格式
            if(response.data.data.introducerNumber==0){
              this.couponSetForm.introducerNumber="0.00";
            }else{
              if (response.data.data.introducerNumber.toString().includes(".")) {
                this.couponSetForm.introducerNumber = response.data.data.introducerNumber.toString().split(".")[1].length < 2 ? response.data.data.introducerNumber.toString() + "0" : response.data.data.introducerNumber;
              }else{
                this.couponSetForm.introducerNumber=response.data.data.introducerNumber.toString()+".00"
              }
            }
          }else if(response.data.data.introducerNumber==0){
            this.couponSetForm.introducerNumber="0.00";
          }else{
            this.couponSetForm.introducerNumber=response.data.data.introducerNumber
          }
          this.couponSetForm.introducerRate=response.data.data.introducerRate
          this.couponSetForm.couponCurrency=response.data.data.couponCurrency
          this.couponSetForm.commissionCurrency=response.data.data.commissionCurrency
          this.oldCouponSetForm=JSON.stringify(this.couponSetForm);
          this.studentNumberOld=this.couponSetForm.studentNumber
          this.studentRateOld=this.couponSetForm.studentRate
          this.introducerNumberOld=this.couponSetForm.introducerNumber
          this.introducerRateOld=this.couponSetForm.introducerRate
          loading.close();
          if(this.couponSetForm.courseName!=null && this.couponSetForm.courseName!=""){
            this.$refs.couponSetFormRef.clearValidate('courseName')
          }
        })
        .catch((err) => {
          loading.close();
          console.log(err);
          this.$message.error(this.$t("p0211.errorOccurred"));
        });
        
    },
    // 改变课程名称
    changeCourseName(){
      if(this.couponSetForm.courseName!=null && this.couponSetForm.courseName!=""){
        this.$refs.couponSetFormRef.clearValidate('courseName')
      }
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container"),
      });
      let url = "/api/couponCode/changeName";
      this.$http
        .post(
          url,qs.stringify({courseName:this.couponSetForm.courseName})
        )
        .then((response) => {
          // console.log("response:" + JSON.stringify(response.data.data));
          this.couponSetForm.field=response.data.data.field
          this.couponSetForm.category=response.data.data.category
          this.couponSetForm.courseNumber=response.data.data.courseNumber
          this.couponSetForm.courseNumber6s=response.data.data.courseNumber6s
          // 学员优惠
           // 学员优惠
          if(response.data.data.couponType!=1){
            // 金额
            this.couponSetForm.couponType="0"
          }else{
            // %
            this.couponSetForm.couponType=response.data.data.couponType
          }
          if(response.data.data.studentNumber!=null && response.data.data.studentNumber!=""){
            // 货币格式
            if(response.data.data.studentNumber==0){
              this.couponSetForm.studentNumber="0.00";
            }else{
              if (response.data.data.studentNumber.toString().includes(".")) {
                this.couponSetForm.studentNumber = response.data.data.studentNumber.toString().split(".")[1].length < 2 ? response.data.data.studentNumber.toString() + "0" : response.data.data.studentNumber;
              }else{
                this.couponSetForm.studentNumber=response.data.data.studentNumber.toString()+".00"
              }
            }
          }else if(response.data.data.studentNumber==0){
            this.couponSetForm.studentNumber="0.00";
          }else{
            this.couponSetForm.studentNumber=response.data.data.studentNumber
          }
          this.couponSetForm.studentRate=response.data.data.studentRate
          // 介绍人优惠
          if(response.data.data.commissionType!=1){
            // 金额
            this.couponSetForm.commissionType="0"
          }else{
            // %
            this.couponSetForm.commissionType=response.data.data.commissionType
          }
          if(response.data.data.introducerNumber!=null && response.data.data.introducerNumber!=""){
            // 货币格式
            if(response.data.data.introducerNumber==0){
              this.couponSetForm.introducerNumber="0.00";
            }else{
              if (response.data.data.introducerNumber.toString().includes(".")) {
                this.couponSetForm.introducerNumber = response.data.data.introducerNumber.toString().split(".")[1].length < 2 ? response.data.data.introducerNumber.toString() + "0" : response.data.data.introducerNumber;
              }else{
                this.couponSetForm.introducerNumber=response.data.data.introducerNumber.toString()+".00"
              }
            }
          }else if(response.data.data.introducerNumber==0){
            this.couponSetForm.introducerNumber="0.00";
          }else{
            this.couponSetForm.introducerNumber=response.data.data.introducerNumber
          }
          this.couponSetForm.introducerRate=response.data.data.introducerRate
          this.couponSetForm.couponCurrency=response.data.data.couponCurrency
          this.couponSetForm.commissionCurrency=response.data.data.commissionCurrency
          this.oldCouponSetForm=JSON.stringify(this.couponSetForm);
          this.studentNumberOld=this.couponSetForm.studentNumber
          this.studentRateOld=this.couponSetForm.studentRate
          this.introducerNumberOld=this.couponSetForm.introducerNumber
          this.introducerRateOld=this.couponSetForm.introducerRate
          loading.close();
          if(this.couponSetForm.courseNumber6s!=null && this.couponSetForm.courseNumber6s!=""){
            this.$refs.couponSetFormRef.clearValidate('courseNumber6s')
          }
        })
        .catch((err) => {
          loading.close();
          console.log(err);
          this.$message.error(this.$t("p0211.errorOccurred"));
        });
    },
    // 改变优惠方式
    changeStuNo(){
      this.couponSetForm.studentRate=""
      this.couponSetForm.studentNumber=this.studentNumberOld
      this.$refs.couponSetFormRef.clearValidate('studentRate')
    },
    changeStuRate(){
      this.couponSetForm.studentNumber=""
      this.couponSetForm.studentRate=this.studentRateOld
      this.$refs.couponSetFormRef.clearValidate('studentNumber')
    },
    changeIntNo(){
      this.couponSetForm.introducerRate=""
      this.couponSetForm.introducerNumber=this.introducerNumberOld
      this.$refs.couponSetFormRef.clearValidate('introducerRate')
    },
    changeIntRate(){
      this.couponSetForm.introducerNumber=""
      this.couponSetForm.introducerRate=this.introducerRateOld
      this.$refs.couponSetFormRef.clearValidate('introducerNumber')
    },
    formatStuNumber(){
      
      this.$refs["couponSetFormRef"].validateField("studentNumber",(valid)=> {
        if (!valid) {
          if(this.couponSetForm.studentNumber!=null && this.couponSetForm.studentNumber!=""){
            // 货币格式
            if(this.couponSetForm.studentNumber==0){
              this.couponSetForm.studentNumber="0.00";
            }else{
              if (this.couponSetForm.studentNumber.toString().includes(".")) {
                this.couponSetForm.studentNumber = this.couponSetForm.studentNumber.toString().split(".")[1].length < 2 ? (this.couponSetForm.studentNumber.toString().split(".")[1].length < 1 ? this.couponSetForm.studentNumber.toString() + "00":this.couponSetForm.studentNumber.toString() + "0" ): this.couponSetForm.studentNumber;
              }else{
                this.couponSetForm.studentNumber=this.couponSetForm.studentNumber.toString()+".00"
              }
            }
          }
        }
      })
    },
    formatIntNumber(){
      this.$refs["couponSetFormRef"].validateField("introducerNumber",(valid) => {
        if (!valid) {
          if(this.couponSetForm.introducerNumber!=null && this.couponSetForm.introducerNumber!=""){
            // 货币格式
            if(this.couponSetForm.introducerNumber==0){
              this.couponSetForm.introducerNumber="0.00";
            }else{
              if (this.couponSetForm.introducerNumber.toString().includes(".")) {
                this.couponSetForm.introducerNumber = this.couponSetForm.introducerNumber.toString().split(".")[1].length < 2 ? (this.couponSetForm.introducerNumber.toString().split(".")[1].length < 1 ? this.couponSetForm.introducerNumber.toString() + "00" : this.couponSetForm.introducerNumber.toString() + "0" ): this.couponSetForm.introducerNumber;
              }else{
                this.couponSetForm.introducerNumber=this.couponSetForm.introducerNumber.toString()+".00"
              }
            }
          }
        }
      })
      this.$refs.couponSetFormRef.clearValidate('courseNumber6s')
      this.$refs.couponSetFormRef.clearValidate('courseName')
    },
  },
  
};
</script>

<style lang="scss" scoped>
.main {
  width: 600px;
  margin: 0 auto;
  padding-top: 17px;
  display: flex;
}
>>> .el-table__row {
  height: 42px;
}
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 14px;
}
>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  line-height: 18px;
  border-bottom: 0.5px solid rgb(170, 170, 170);
}
>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}
>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}
.foot-container {
  margin-top: 5%;
  margin-left: 38%;
  width: 20%;
  text-align: center;
}
>>>.el-radio{
  display: block;
  margin-top: 15px;
  margin-bottom: 19px;
  // margin:10px 0;
}
>>>.el-input--small .el-input__inner{
  text-align: right
}
</style>



// WEBPACK FOOTER //
// src/views/Marketing/CouponCode/P0412.vue